import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";

import { useNavigate } from "react-router-dom";
import "../../assets/styles/ReportsView.css";
import { Badge, Button, Modal } from "react-bootstrap";
import OpportunityModal from "../modals/opportunityModal/OpportunityModal";

import apiService from "../../services/apiService";
import { useToast } from "../../hooks/useToast";

const TowerView = ({ towerData, setTowerData, loading, totalCount }) => {
  const { addToast } = useToast();
  const [sortOrder, setSortOrder] = useState({
    key: "serialNumber",
    direction: "asc",
  });
  const [selectedProject, setSelectedProject] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showFinalDeleteModal, setShowFinalDeleteModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [towerToDelete, setTowerToDelete] = useState(null);
  const [towerToDuplicate, setTowerToDuplicate] = useState(null);
  const [showOpportunityModal, setShowOpportunityModal] = useState(false);
  const [selectedTower, setSelectedTower] = useState(null);
  const [formattedTowerData, setformattedTowerData] = useState({});
  const [towerId, setTowerId] = useState("");
  const [towerList, setTowerList] = useState([]);
  const [newTowerId, setNewTowerId] = useState(null);
  const [selectedSerialNumber, setSelectedSerialNumber] = useState(null);

  const navigate = useNavigate();
  const handleShowDeleteModal = (towerId) => {
    setTowerToDelete(towerId);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setTowerToDelete(null);
    setShowDeleteModal(false);
  };

  const handleFirstDeleteConfirmation = () => {
    setShowDeleteModal(false);
    setShowFinalDeleteModal(true);
  };

  const handleCloseFinalDeleteModal = () => {
    setShowFinalDeleteModal(false);
    setTowerToDelete(null);
  };

  const DuplicateTowerModal = ({ show, onHide, tower, onConfirm }) => {
    const [newTowerName, setNewTowerName] = useState("");

    const handleConfirm = () => {
      onConfirm(newTowerName);
      setNewTowerName("");
    };

    return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>Duplicate Tower</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to duplicate this tower?</p>
          <div className="form-group">
            <label>Customer Tower Designation:</label>
            <input
              type="text"
              className="form-control"
              value={newTowerName}
              onChange={(e) => setNewTowerName(e.target.value)}
              placeholder="Enter new tower name"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={!newTowerName.trim()}
          >
            Duplicate
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const { user } = useAuth();
  const handleShowDuplicateModal = (tower) => {
    tower.towerInfo.generalTowerDescription.submitter = user?.name || "Guest";
    tower.towerInfo.generalTowerDescription.submitter_email = user?.email || "";
    setTowerToDuplicate(tower);
    setShowDuplicateModal(true);
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortOrder.key === key && sortOrder.direction === "asc") {
      direction = "desc";
    }
    const sortedData = [...towerData].sort((a, b) => {
      switch (key) {
        case "accountName":
          const aName = a.towerInfo?.companyInfo?.company_name || "";
          const bName = b.towerInfo?.companyInfo?.company_name || "";
          return direction === "asc"
            ? aName.localeCompare(bName)
            : bName.localeCompare(aName);

        case "serialNumber":
          const aSerial =
            a.towerInfo?.generalTowerDescription?.serialNumber || "";
          const bSerial =
            a.towerInfo?.generalTowerDescription?.serialNumber || "";
          return direction === "asc"
            ? aSerial.localeCompare(bSerial)
            : bSerial.localeCompare(aSerial);

        case "submitter":
          const aSubmitter =
            a.towerInfo?.generalTowerDescription?.submitter || "";
          const bSubmitter =
            a.towerInfo?.generalTowerDescription?.submitter || "";
          return direction === "asc"
            ? aSubmitter.localeCompare(bSubmitter)
            : bSubmitter.localeCompare(aSubmitter);

        case "primaryState":
          const aState = a.towerInfo?.generalTowerDescription?.state || "";
          const bState = b.towerInfo?.generalTowerDescription?.state || "";
          return direction === "asc"
            ? aState.localeCompare(bState)
            : bState.localeCompare(aState);

        case "towerType":
          const aType = a.towerInfo?.towerType || "";
          const bType = b.towerInfo?.towerType || "";
          return direction === "asc"
            ? aType.localeCompare(bType)
            : bType.localeCompare(aType);

        default:
          return 0;
      }
    });

    setTowerData(sortedData);
    setSortOrder({ key, direction });
  };

  const handleViewDetails = async (towerInfo) => {
    try {
      const towerList = await apiService.get(
        `/tower/getTowerData/${towerInfo.dealId}`
      );
      setTowerList(towerList?.data || []);

      const m_towerInfo =
        towerList?.data?.find((tower) => tower.id === towerInfo._id) ||
        towerList?.data?.[0];

      setSelectedSerialNumber(
        m_towerInfo?.towerInfo?.generalTowerDescription?.serialNumber
      );

      setSelectedProject(towerInfo?.opportunity?.[0]?.data);
      setSelectedTower(m_towerInfo);
      setTowerId(m_towerInfo?.id || "");
      setShowOpportunityModal(true);

      if (m_towerInfo?.towerInfo) {
        // Extract GTD data from generalTowerDescription
        const gtdData = m_towerInfo.towerInfo.generalTowerDescription || {};
        if (!gtdData) {
          throw new Error("No general tower description found");
        }

        let formattedData = {
          ...m_towerInfo.towerInfo,
          generalTowerDescription: {
            ...m_towerInfo.towerInfo.generalTowerDescription,

            // General Information
            manufacturer: gtdData.manufacturer,
            model: gtdData.model,
            customer_tower_designation: gtdData.customer_tower_designation,
            serialNumber: gtdData.serialNumber,
            submitter: gtdData.submitter,
            submitter_email: gtdData.submitter_email,
            statusReason: gtdData.statusReason,
            tower_notes: gtdData.tower_notes || "",

            // Location
            city: gtdData.city,
            state: gtdData.state,
            street: gtdData.street,
            zip: gtdData.zip,

            // Tower Configuration
            tower: {
              type: m_towerInfo.towerInfo.towerType,
              subtype: gtdData.tower?.subtype || "",
              distribution_system: gtdData.tower?.distribution_system || "",
              ...gtdData.tower,
              distributionSystemXF: gtdData.distributionSystem || {},
              distributionSystemCF: gtdData.distributionSystem || {},
            },

            // Dimensions
            numberOfCells: gtdData.numberOfCells,
            cellLength: gtdData.cellLength,
            cellWidth: gtdData.cellWidth,
            cellHeight: gtdData.cellHeight,
            baySizeLength: gtdData.baySizeLength,
            baySizeWidth: gtdData.baySizeWidth,
            baySizeHeight: gtdData.baySizeHeight,
            cwb_grade_to_curb_height: gtdData.cwb_grade_to_curb_height,
            airInletHeight: gtdData.airInletHeight,
            casing_air_inlets: gtdData.casing_air_inlets,
            dist_header_cl_cwb_curb: gtdData.dist_header_cl_cwb_curb,

            // Components
            structure: gtdData.structure || {},
            stairway_count: gtdData.stairway_count || 0,
            ladder_count: gtdData.ladder_count || 0,
            mechanical: {
              motor_hp: gtdData.motor_hp,
              fan_diameter: gtdData.fan_diameter,
              fanstack_height: gtdData.fanstack_height,
              ...gtdData.mechanical,
            },
            fill: {
              fill_type: gtdData.fill?.fill_type || "",
              fill_type_xf:
                m_towerInfo.towerInfo.towerType === "crossflow"
                  ? gtdData.fill?.fill_type || ""
                  : "",
              fill_type_cf:
                m_towerInfo.towerInfo.towerType === "counterflow"
                  ? gtdData.fill?.fill_type || ""
                  : "",
              ...gtdData.fill,
            },
            louvers: {
              exists: gtdData.louvers?.exists || "no",
              louver_exists_xf:
                m_towerInfo.towerInfo.towerType === "crossflow"
                  ? gtdData.louvers?.exists || "no"
                  : "no",
              louver_exists_cf:
                m_towerInfo.towerInfo.towerType === "counterflow"
                  ? gtdData.louvers?.exists || "no"
                  : "no",
              louverBladeWidth: gtdData.louvers?.louverBladeWidth || "",
              louver_blade_width_xf:
                m_towerInfo.towerInfo.towerType === "crossflow"
                  ? gtdData.louvers?.louverBladeWidth || ""
                  : "",
              louver_blade_width_cf:
                m_towerInfo.towerInfo.towerType === "counterflow"
                  ? gtdData.louvers?.louverBladeWidth || ""
                  : "",
              ...gtdData.louvers,
            },

            // Additional Info
            towetower_notesrNotes: gtdData.tower_notes || "",
          },
        };
        //since towerInfo.generalTowerDescription has some duplicate fields with towerInfo.components...
        formattedData = {
          ...formattedData,
          components: {
            ...formattedData.components,
            structure: {
              ...formattedData.generalTowerDescription.structure,
            },
            louvers: {
              ...formattedData.generalTowerDescription.louvers,
            },
            fill: {
              ...formattedData.generalTowerDescription.fill,
            },
          },
        };
        console.log("GTD Data:", formattedData);

        setformattedTowerData(formattedData);
      }
    } catch (error) {
      console.error("Error loading tower details:", error);
      addToast("Error loading tower details", "danger");
    }
  };

  const handleCloseOpportunityModal = () => {
    setShowOpportunityModal(false);
    setSelectedTower(null);
  };

  const getTowerData = async (id) => {
    try {
      // const response = await apiService.get(`/tower/getTowerData/${id}`);
      const response = await apiService.get(`/tower/serialNumber/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching tower data:", error);
      return null;
    }
  };

  const handleImport = async (item) => {
    try {
      // const existingTowerResponse = await getTowerData(item.dealId);
      const existingTowerResponse = await getTowerData(
        item.towerInfo.generalTowerDescription.serialNumber
      );

      let mostRecentTower = null;
      if (existingTowerResponse && existingTowerResponse.length > 0)
        //when using item.dealId
        mostRecentTower = existingTowerResponse[0];
      if (existingTowerResponse && existingTowerResponse.towerInfo)
        //when using item.towerInfo.generalTowerDescription.serialNumber
        mostRecentTower = existingTowerResponse;

      if (mostRecentTower != null) {
        console.log("Most recent tower full data:", mostRecentTower);

        navigate("/createTower", {
          state: {
            initialData: mostRecentTower,
            dealId: item.dealId,
            status: mostRecentTower.status,
            isUpdate: true,
            _id: item._id,
          },
        });
      }
    } catch (error) {
      console.error("Error in handleImport:", error);
      addToast("Error loading tower data", "danger");
    }
  };

  const handleDuplicate = async (newTowerName) => {
    try {
      const response = await apiService.post("/tower/duplicate", {
        towerInfo: towerToDuplicate.towerInfo,
        newTowerName,
        projectId: towerToDuplicate.dealId,
      });

      if (response.status === 201) {
        const originalIndex = towerData.findIndex(
          (t) => t._id === towerToDuplicate._id
        );
        const newTowerData = [...towerData];
        newTowerData.splice(originalIndex + 1, 0, response.data);

        if (newTowerData.length > 10) {
          newTowerData.pop();
        }

        setNewTowerId(response.data._id);
        setTowerData(newTowerData);
        addToast("Tower duplicated successfully");
        setShowDuplicateModal(false);

        setTimeout(() => {
          setNewTowerId(null);
        }, 3000);
      }
    } catch (error) {
      console.error("Error duplicating tower:", error);
      addToast("Error duplicating tower", "danger");
    }
  };

  const getActionButtons = (item) => {
    return (
      <div className="d-flex gap-2 justify-content-center">
        <Button
          size="sm"
          variant="secondary"
          onClick={() => handleImport(item)}
          title="Edit General Tower Description"
        >
          <i className="bi bi-pencil-square"></i>
        </Button>
        <Button
          size="sm"
          variant="info"
          onClick={() => handleViewDetails(item)}
          disabled={!item.dealId}
          title="View Tower Details/Opportunity"
        >
          <i className="bi bi-eye"></i>
        </Button>
        <Button
          size="sm"
          variant="success"
          onClick={() => handleShowDuplicateModal(item)}
          title="Duplicate Tower"
        >
          <i className="bi bi-files"></i>
        </Button>
        <Button
          size="sm"
          variant="danger"
          onClick={() => handleShowDeleteModal(item._id)}
          title="Delete Tower"
        >
          <i className="bi bi-trash3"></i>
        </Button>
      </div>
    );
  };
  const handleDelete = async () => {
    try {
      const response = await apiService.delete(`/tower/${towerToDelete}`);
      if (response.status === 200) {
        setTowerData(towerData.filter((tower) => tower._id !== towerToDelete));
        addToast("Tower deleted successfully");
      }
    } catch (error) {
      console.error("Error deleting tower:", error);
      addToast("Failed to delete tower", "danger");
    }
    setShowFinalDeleteModal(false);
    setTowerToDelete(null);
  };

  const capitalizeFirstLetter = (string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : "";
  };

  return (
    <>
      <div className="opportunity-view">
        <div className="tower-header">
          <p className="opportunities-total">Total Towers: {totalCount}</p>
        </div>

        <div className="table-wrapper">
          <div className="table-container">
            <table className="table table-striped custom-table-header">
              <thead className="sticky-header">
                <tr>
                  <th className="text-center">Status</th>
                  <th
                    className="text-center"
                    onClick={() => handleSort("accountName")} // Change sort key
                  >
                    Company Name{" "}
                    {sortOrder.key === "accountName" && // Update sort key check
                      (sortOrder.direction === "asc" ? "↑" : "↓")}
                  </th>
                  <th
                    className="text-center"
                    onClick={() => handleSort("serialNumber")}
                  >
                    Serial Number{" "}
                    {sortOrder.key === "serialNumber" &&
                      (sortOrder.direction === "asc" ? "↑" : "↓")}
                  </th>
                  <th
                    className="text-center"
                    onClick={() => handleSort("submitter")}
                  >
                    Submitter{" "}
                    {sortOrder.key === "submitter" &&
                      (sortOrder.direction === "asc" ? "↑" : "↓")}
                  </th>
                  <th
                    className="text-center"
                    onClick={() => handleSort("primaryState")}
                  >
                    State{" "}
                    {sortOrder.key === "primaryState" &&
                      (sortOrder.direction === "asc" ? "↑" : "↓")}
                  </th>
                  <th
                    className="text-center"
                    onClick={() => handleSort("towerType")}
                  >
                    Tower Type{" "}
                    {sortOrder.key === "towerType" &&
                      (sortOrder.direction === "asc" ? "↑" : "↓")}
                  </th>
                  <th className="text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : towerData?.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No Tower Data
                    </td>
                  </tr>
                ) : (
                  towerData?.map((item) => {
                    const { towerInfo } = item;
                    const { generalTowerDescription } = towerInfo || {};
                    const { serialNumber, state } =
                      generalTowerDescription || {};
                    const status = item.status || "Pending";
                    const isNewTower = item._id === newTowerId;

                    return (
                      <tr
                        key={item._id || item.id}
                        className={isNewTower ? "highlight-new" : ""}
                        style={
                          isNewTower
                            ? { transition: "background-color 3s" }
                            : undefined
                        }
                      >
                        <td className="text-center align-middle">
                          <Badge
                            bg=""
                            className={`px-3 py-2 rounded-pill ${
                              status === "Approved"
                                ? "bg-custom-approved"
                                : status === "Rejected"
                                ? "bg-custom-rejected"
                                : status === "Auto Approved"
                                ? "bg-custom-approved"
                                : status === "Pending"
                                ? "bg-custom-pending"
                                : status === "Resubmit"
                                ? "bg-custom-resubmit"
                                : status === "In Progress"
                                ? "bg-custom-inprogress"
                                : "bg-secondary" // default color if none of the conditions match
                            }`}
                          >
                            Tower {status}
                          </Badge>

                          <Badge
                            bg=""
                            className={`px-3 py-2 rounded-pill ${
                              item.opportunity &&
                              item.opportunity[0]?.data?.Stage === "Closed Won"
                                ? "bg-custom-won"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage === "Budget"
                                ? "bg-custom-budget"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage === "Lead"
                                ? "bg-custom-lead"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage === "Actual"
                                ? "bg-custom-actual"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage ===
                                    "Pending Proposal Actual"
                                ? "bg-custom-actual"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage ===
                                    "Inactive"
                                ? "bg-custom-inactive"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage ===
                                    "Closed Lost"
                                ? "bg-custom-lost"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage ===
                                    "Pending Proposal Budget"
                                ? "bg-custom-budget"
                                : item.opportunity &&
                                  item.opportunity[0]?.data?.Stage === "Deleted"
                                ? "bg-custom-lost"
                                : "bg-secondary" // default color if none of the conditions match
                            }`}
                          >
                            {(item.opportunity &&
                              item.opportunity[0]?.data?.Stage) ||
                              "N/A"}
                          </Badge>
                        </td>
                        <td className="text-center align-middle">
                          {(item.opportunity &&
                            item.opportunity[0]?.data?.Account_Name?.name) ||
                            "N/A"}
                        </td>
                        <td className="text-center align-middle">
                          {serialNumber || "N/A"}
                        </td>
                        <td className="text-center align-middle">
                          {item?.towerInfo?.generalTowerDescription
                            ?.submitter || "N/A"}
                        </td>
                        <td className="text-center align-middle">
                          {state || "N/A"}
                        </td>
                        <td className="text-center align-middle">
                          {capitalizeFirstLetter(towerInfo?.towerType) || "N/A"}
                        </td>

                        <td className="text-center align-middle">
                          {getActionButtons(item)}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <OpportunityModal
        show={showOpportunityModal}
        handleClose={handleCloseOpportunityModal}
        project={selectedProject}
        towerInfo={selectedTower}
        towerList={towerList}
        setTowerInfo={setSelectedTower}
        formattedTowerData={formattedTowerData}
        setformattedTowerData={setformattedTowerData}
        modalLoading={loading}
        onChange={() => {}}
        towerId={towerId}
        initialSerialNumber={selectedSerialNumber}
      />
      {/* Duplicate Tower Modal */}
      <DuplicateTowerModal
        show={showDuplicateModal}
        onHide={() => setShowDuplicateModal(false)}
        tower={towerToDuplicate}
        onConfirm={handleDuplicate}
      />{" "}
      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Tower</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this tower?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            No
          </Button>
          <Button variant="danger" onClick={handleFirstDeleteConfirmation}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Final Delete Confirmation Modal */}
      <Modal
        show={showFinalDeleteModal}
        onHide={handleCloseFinalDeleteModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-danger fw-bold">WARNING:</p>
          <p>
            We just want to make it absolutely clear that you are going to
            delete a cooling tower and all of the scopes and components that are
            associated with it.
          </p>
          <p>This action cannot be undone.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseFinalDeleteModal}>
            Cancel
          </Button>{" "}
          <Button variant="danger" onClick={handleDelete}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TowerView;
